function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import { StyledExpandingSignupComponent, TRANSITION_TIMING_MILISECONDS } from "./expanding-signup-component.scss";
import { SIGNUP_FORM_GET_STARTED_CLICKED } from "/constants/bigbrain-event-types";
import colors from "/styles/colors";
import { TABLET_QUERY_MAX_WIDTH_MEDIA_QUERY } from "/constants/vp-sizes";
import SignupCoreComponent from "components/core/signups/base-signup-form/signup-form-core/signup-form-core-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import withErrorHandler from "/components/enhancements/input-error-handler/input-error-handler";
const SECOND_CTA_KEY = "signup.secondCta";
class ExpandingSignupComponent extends PureComponent {
    componentDidMount() {
        if (window.matchMedia(TABLET_QUERY_MAX_WIDTH_MEDIA_QUERY).matches) {
            this.setState({
                emailInputOpened: true
            });
        }
    }
    getSecondCtaButtonText() {
        const { translate } = this.props;
        return translate(SECOND_CTA_KEY); //removed from default props because of localization
    }
    render() {
        const { buttonColor, alignCenter } = this.props;
        const { emailInputOpened, useSecondCTA } = this.state;
        const onClick = emailInputOpened ? null : this.handleShowInput;
        const ctaText = useSecondCTA ? this.getSecondCtaButtonText() : null;
        const borderColor = colors[buttonColor];
        return /*#__PURE__*/ _jsx(StyledExpandingSignupComponent, {
            className: classnames("signup-form-core-outer-wrapper", {
                "align-center": alignCenter
            }),
            children: /*#__PURE__*/ _jsx(SignupCoreComponent, _object_spread_props(_object_spread({
                ref: (el)=>this._signupComponent = el
            }, this.props), {
                emailInputOpened: emailInputOpened,
                borderColor: borderColor,
                ctaText: ctaText,
                useCtaText: !!ctaText,
                placeholderFocusColor: borderColor
            }))
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "handleShowInput", ()=>{
            const { placement } = this.props;
            const transitionTime = TRANSITION_TIMING_MILISECONDS;
            BigBrain("track", SIGNUP_FORM_GET_STARTED_CLICKED, {
                placement
            });
            this.setState({
                emailInputOpened: true,
                useSecondCTA: true
            }, ()=>setTimeout(()=>{
                    this._signupComponent.focusOnInput();
                }, transitionTime));
        });
        this.state = {
            emailInputOpened: props.emailInputOpened,
            useSecondCTA: false
        };
        this._signupComponent = null;
    }
}
ExpandingSignupComponent.defaultProps = {
    emailInputOpened: true,
    alignCenter: false,
    focusOnLoad: false,
    focusTimeout: 0,
    buttonColor: "brand-pink"
};
export default withErrorHandler(withGenericConfig(ExpandingSignupComponent));
